<script>
import Vue from 'vue';
import { Icon } from 'ant-design-vue';
Vue.use(Icon);
export default Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1303391_kzld3r3csw.js'
});
</script>



// WEBPACK FOOTER //
// src/components/icon.vue